import { cn } from "@cloai/uikit";

export const START_CARD_STYLES = {
  wrapper: cn(
    "group/item relative size-full cursor-pointer overflow-hidden rounded-xl select-none",
    "flex items-center justify-center bg-card-border duration-300",
    "after:pointer-events-none after:absolute after:size-full after:bg-card/20",
    "hover:bg-[oklch(from_var(--color-card-border)_calc(l_+_0.1)_c_h)]",
    "active:scale-95 active:bg-[oklch(from_var(--color-card-border)_calc(l_+_0.05)_c_h)] active:duration-100",
  ),
  disabled: cn("pointer-events-none opacity-70"),
  image: {
    base: cn(
      "pointer-events-none block size-full object-bottom duration-300",
      "group-hover/item:scale-103 group-hover/item:duration-800",
    ),
    variant: {
      squad: "object-cover @sm:object-contain",
      wide: "object-contain",
    },
  },
  text: cn(
    "relative z-1 text-center text-2xl font-bold text-balance text-white uppercase text-shadow-md",
    "md:text-3xl",
  ),
};

export const START_CARD_STYLES_V2 = {
  title: cn(
    "text-center font-bold text-balance uppercase",
    "text-[clamp(1.5rem,min(5vw,5vh),3rem)]",
  ),
  grid: cn(
    "grid w-full flex-grow-1 grid-cols-1 grid-rows-9 place-items-stretch gap-indent overflow-hidden",
    "md:grid-cols-2 md:grid-rows-6 md:gap-6",
  ),
  card: {
    base: cn(
      "group/item @container relative cursor-pointer overflow-hidden select-none",
      "size-full rounded-xl p-5",
      "flex items-end justify-center bg-card-border duration-300",
      "hover:bg-[oklch(from_var(--color-card-border)_calc(l_+_0.1)_c_h)]",
      "active:scale-95 active:bg-[oklch(from_var(--color-card-border)_calc(l_+_0.05)_c_h)] active:duration-100",
    ),
    variant: {
      primary: cn("row-span-3", "md:row-span-6"),
      secondary: cn("row-span-3", "md:row-span-3"),
      regular: cn("row-span-2"),
      group: cn(
        "flex size-full items-center justify-center gap-indent rounded-2xl",
        "md:gap-6",
      ),
    },
    disabled: cn("pointer-events-none opacity-70"),
  },
  prompt: cn(
    "@container relative cursor-pointer overflow-hidden rounded-xl bg-secondary/50 p-0 duration-300 select-none",
    "flex items-center justify-center",
    "hover:bg-[oklch(from_var(--color-secondary)_calc(l_+_0.1)_c_h)]",
    "active:scale-95 active:bg-[oklch(from_var(--color-secondary)_calc(l_+_0.05)_c_h)] active:duration-100",
  ),
  image: cn(
    "pointer-events-none block size-full object-cover duration-300",
    "group-hover/item:scale-103 group-hover/item:duration-800",
  ),
  text: {
    base: cn(
      "relative text-center text-container-15 font-bold text-balance text-white uppercase",
    ),
    variant: {
      bottom: cn("absolute bottom-3", "md:bottom-5"),
      primary: cn("text-container-30 text-primary"),
      stroke: cn("text-transparent"),
    },
  },
  badge: cn(
    "absolute top-3 right-3 flex animate-pulse items-center justify-center gap-1 text-white opacity-80",
  ),
};
